import clsx from 'clsx';
import Link from 'next/link';

import { cloudinaryUrl } from '@/utils/utils';
import styles from './card-list.module.css';

/** nombre de vignettes en éventail sur la carte « voir plus » */
const PREVIEW_COUNT = 4
/** taille d'une vignette bordure comprise, en px (cf. --link-card-picture-size / -border) */
const PREVIEW_SIZE = 71
const PREVIEW_BORDER = 3
/** taille réellement occupée par l'image, sans la bordure */
const PREVIEW_IMAGE_SIZE = PREVIEW_SIZE - PREVIEW_BORDER * 2

/** aperçu des cartes suivantes d'abord, complété par les cartes affichées */
export const getPreviewImages = (images: (string | undefined)[] = [], visibleCount: number) => [...new Set(
  [...images.slice(visibleCount), ...images.slice(0, visibleCount)].filter(Boolean) as string[]
)].slice(0, PREVIEW_COUNT)

type MoreCardProps = {
  label: string,
  images: string[],
  /** occupe toute la largeur de sa colonne (grille) au lieu de la largeur d'une carte du carousel */
  fluid?: boolean,
} & ({ href: string, onClick?: never } | { onClick: () => void, href?: never })

/** carte « voir plus » : lien vers la liste complète, ou bouton qui affiche la suite */
export const MoreCard = ({label, images, fluid, href, onClick}: MoreCardProps) => {
  const content = (
    <>
      {images.length > 0 && (
        <span className={styles.pictures} aria-hidden>
          {images.map(image => (
            <img
              key={image}
              className={styles.picture}
              src={cloudinaryUrl({src: image, width: PREVIEW_IMAGE_SIZE, params: [`h_${PREVIEW_IMAGE_SIZE}`]})}
              srcSet={`${cloudinaryUrl({src: image, width: PREVIEW_IMAGE_SIZE * 2, params: [`h_${PREVIEW_IMAGE_SIZE * 2}`]})} 2x`}
              width={PREVIEW_SIZE}
              height={PREVIEW_SIZE}
              loading='lazy'
              alt=''/>
          ))}
        </span>
      )}
      <span className={styles.label}>{label}</span>
    </>
  )
  const className = clsx(styles.linkCard, fluid && styles.fluid)

  return href !== undefined ? (
    <Link href={href} prefetch={false} className={className} aria-label={`Tout afficher : ${label}`}>{content}</Link>
  ) : (
    <button type='button' className={className} onClick={onClick}>{content}</button>
  )
}
